
import Navbar from '../Navbar';
import React, { useState, useEffect, useMemo } from "react";
import { UrlApi } from '../../services/apirest';
import MaterialReactTable, {
    MRT_ShowHideColumnsButton,
    MRT_FullScreenToggleButton,
    MRT_ToggleDensePaddingButton,
    MRT_ToggleFiltersButton,
    MRT_SortingFn,
  } from "material-react-table";

  import {
    // Componentes para los estilos
    Container,
    Typography,
    Snackbar,
    Alert,
    SnackbarContent,
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    MenuItem,
    Stack,
    TextField,
    Tooltip,
    Grid,
  } from "@mui/material";
  import { Delete, Edit } from "@mui/icons-material";
  import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
  import PersonOffTwoToneIcon from "@mui/icons-material/PersonOffTwoTone";
  import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
  import AppRegistrationTwoToneIcon from "@mui/icons-material/AppRegistrationTwoTone";
  import PersonAddTwoToneIcon from "@mui/icons-material/PersonAddTwoTone";
  import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
  import PersonRemoveTwoToneIcon from "@mui/icons-material/PersonRemoveTwoTone";
  import PersonTwoToneIcon from "@mui/icons-material/PersonTwoTone";
  import HowToRegTwoToneIcon from '@mui/icons-material/HowToRegTwoTone';
  import DialogContentText from "@mui/material/DialogContentText";
  import moment from "moment";
  import { MRT_Localization_ES } from "material-react-table/locales/es"; //idioma
  import SearchIcon from '@mui/icons-material/Search';


function Evepanelctrl() {

const [logs, setLogs] = useState([])
const [tabla, setTabla] = useState(true)
const [alta, setAlta] = useState(false)
const [modificaciones, setModificaciones] = useState(false)
const [updatetabla, setUpdatetabla] = useState(false);
const [datosrow, setDatosrow] = useState([])  //datos para modificar
const [datosvoid, setDatosvoid] = useState({  //datos vacios para alta
  logs:"", 
})
console.log("consulta logs",logs)


useEffect(() => {
if (updatetabla) Obtenerlogs();
}, [updatetabla]);

const handleAlta = ()=>{
setAlta(true);
console.log("alta");
}
const handleModificar = (row)=>{
setModificaciones(true);
setDatosrow(row);
console.log("row",(row))
}


const columns = useMemo(() => [  //datos al 30%
{
  accessorKey: "id",
  header: "id",
  size: 75,
  // muiTableBodyCellProps: {
  //   align: 'right',
  // },
},
{
  accessorKey: "evento",
  header: "Evento",
  size: 50,
},
{
  accessorKey: "menu",
  header: "Menú",
  size: 50,
},
{
  accessorKey: "accion",
  header: "Acción",
  size: 50,
},
{
  accessorKey: "user",
  header: "Usuario",
  size: 50,
},
{
 // accessorKey: "created_at",
  header: "Fecha/hora",
  size: 50,
   accessorFn : ( logs ) => moment(logs.created_at).format("DD-MM-YYYY HH:mm"),  
},
// {
//   accessorKey: "ip_address",
//   header: "ip_address",
//   size: 50,
// },
]);

//##########################################################
  const [consulta , setConsulta] = useState({ 
    user:"",
    desde:"",
    hasta:"",
   
   });  
   console.log("consulta user",consulta)
const [fechasvalidas, setFechasvalidas] = useState (false)
console.log("fechasvalidas",fechasvalidas)

  const [errorfecha, setErrorfecha] = useState(false);
  const [disBtn, setDisBtn] = useState(false);
  const [mensajefecha, setMensajefecha] = useState('');

  // Estado para mostrar el mensaje
const [mostrarAlerta, setMostrarAlerta] = useState(false);

const validarFechas = () => {
  const fecha_desde = moment(consulta.desde);
  const fecha_hasta = moment(consulta.hasta);

  if (fecha_desde.isValid() && fecha_hasta.isValid()) {
    if (fecha_hasta.isBefore(fecha_desde)) {
      setMensajefecha('Fecha hasta no puede ser menor a Fecha desde');
      setErrorfecha(true);
      return false;
    } else {
      setErrorfecha(false);
      setMensajefecha('');
      return true;
    }
  } else {
    setMensajefecha('Ambas fechas deben ser válidas');
    setErrorfecha(true);
    return false;
  }
};



//  Función para obtener logs
const Obtenerlogs = async () => {
  const fechasOk = validarFechas();
  if (!consulta.user || !fechasOk) return;

  const res = await fetch(`${UrlApi}/userauths/obtenerlogsrango?user=${consulta.user}&desde=${consulta.desde}&hasta=${consulta.hasta}`);
  const data = await res.json();

  setLogs(data);

  // Mostrar alerta si no se encontraron logs
  if (data.length === 0) {
    setMostrarAlerta(true);
  }
};

// Para cerrar el mensaje
const handleCloseAlerta = (event, reason) => {
  if (reason === 'clickaway') return;
  setMostrarAlerta(false);
};


 function almacenar(e) { 
   setConsulta({    
     ...consulta,
   [e.target.name]: e.target.value,
 });
 };


 const handleBuscar = () => {
  const fechasOk = validarFechas();
  if (consulta.user && fechasOk) {
    Obtenerlogs();
  }
};



  return (
    <>
      <Box
    sx={{
      minHeight: '100vh',           // ocupa toda la altura de la pantalla
      backgroundColor: '#f0f2f5',   // color de fondo general
      padding: '20px',              // espaciado interior
    }}
  > 
      <Navbar />  {/* dejo las propiedades del nuevo mrt  */}
      <br />
      <br />
  {tabla && (
      
          <MaterialReactTable

          
  muiTableBodyProps={{
    sx: {
      backgroundColor: "#ffffff",
    }
  }}
  muiTableBodyCellProps={{
    sx: {
      fontSize: "0.85rem",
      padding: "8px",
      borderBottom: "1px solid #e0e0e0",
    }
  }}
  muiTableHeadCellProps={{
    sx: {
      backgroundColor: "#e3e8f0",
      fontWeight: "bold",
      fontSize: "0.9rem",
      color: "#333",
    }
  }}
  muiTableBodyRowProps={({ row }) => ({
    sx: {
      backgroundColor: row.index % 2 === 0 ? "#fdfdfd" : "#f2f4f7", // filas alternas
      '&:hover': {
        backgroundColor: "#e6f0fa", // hover en filas
      }
    }
  })}
            renderTopToolbarCustomActions={() => (
              <>
                <Typography component="span" variant="h6" >
                Logs de eventos.
                </Typography>


   <Grid container spacing={2} alignItems="center" wrap="wrap">
  <Grid item xs={12} sm={3}>
    <TextField
      fullWidth
      size="small"
      color="primary"
      focused
      label="Usuario"
      name="user"
      value={consulta.user}
      onChange={almacenar}
    />
  </Grid>

  <Grid item xs={12} sm={3.5}>
    <TextField
      fullWidth
      size="small"
      color="primary"
      focused
      label="Fecha Desde"
      name="desde"
      type="date"
      value={consulta.desde}
      onChange={almacenar}
    />
  </Grid>

  <Grid item xs={12} sm={3.5}>
    <TextField
      fullWidth
      size="small"
      color="primary"
      focused
      label="Fecha Hasta"
      name="hasta"
      type="date"
      value={consulta.hasta}
      onChange={almacenar}
      error={errorfecha}
      helperText={errorfecha ? mensajefecha : ''}
    />
  </Grid>

  <Grid item xs={12} sm={1}>
    <IconButton
      onClick={handleBuscar}
      color="primary"
      aria-label="buscar"
      sx={{ mt: 1 }}
    >
      <SearchIcon />
    </IconButton>
  </Grid>
</Grid>

    
     


              </>
            )}

            // componentes toolbar personalizado
            // renderToolbarInternalActions={({ table }) => (
            //   <>
            //     <Tooltip arrow placement="right" title="Alta categorias">
            //       <Button onClick={handleAltatareas}>
            //         <PersonAddTwoToneIcon />
            //       </Button>
            //     </Tooltip>
            //     <MRT_FullScreenToggleButton table={table} />
            //   </>
            // )}
            initialState={{
              showGlobalFilter: true, 
              density: "compact",
            }}
            columns={columns}
            data={logs}
            enableTopToolbar={true} 
            enableColumnFilters={true} 
            enableGlobalFilter={true}
            enableDensityToggle={false} 
            localization={MRT_Localization_ES} 
            muiTablePaperProps={{  //para estilo 
              sx: {
               // maxWidth: 'md',
                //m: 'auto'
              //maxheight
                 maxWidth: 'xl',
             m: 'auto',
             backgroundColor: "#f8f9fb", // fondo general de la tabla
             // borderRadius: "12px",
            boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
              }

              
            }}
            // muiTableBodyCellProps = { ({ row }) => ({
            //   align: "left"
            //   // style: { backgroundColor: row.original.isActive ? 'lightgreen' : 'lightcoral' }
            // })}
            //propiedades columna acction  ----agregar acciones  encabezado columna
            // displayColumnDefOptions={{
            //   "mrt-row-actions": {
            //     header: (
            //       <span>
            //         ACCIONES
            //       </span>
            //     ),
            //     size: 50,
            //   },
            // }}
            positionActionsColumn="last" //first o last posicion de los accion elementos de la fila
           // enableRowActions // habilitar acciones
            //render acciones
            // renderRowActions={({ row, table }) => (
  
            //   <Box sx={{ display: "flex", gap: "1rem" }}>
            //     <Tooltip arrow placement="left" title="Modificar ">                                                                  
            //       <IconButton color="primary" onClick={() => handleModificar(row.original)}> 
            //         <EditTwoToneIcon />
            //       </IconButton>
            //     </Tooltip>
            //    </Box>
            //    // color	'inherit'| 'default'| 'primary'| 'secondary'| 'error'| 'info'| 'success'| 'warning'| string
  
            // )}
          />
        )}

    
    </Box>

    <Snackbar
  open={mostrarAlerta}
  autoHideDuration={4000}
  onClose={handleCloseAlerta}
  anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
>
  <Alert onClose={handleCloseAlerta} severity="info" variant="filled">
    No se encontraron Eventos en la Fecha indicada.
  </Alert>
</Snackbar>

    </>
  )
}

export default Evepanelctrl